// @ts-ignore
import Barchart from "./barchart.svg?react"
import {
  PerformanceBarWrapper,
} from "./PerformanceBar.styles"

export interface Props {
  completed: number
  assigned: number
  unassigned: number
  multiplier: number
  max: number
}

export default function PerformanceBar(props: Props) {
  let total = props.completed + props.assigned + props.unassigned
  let completed =
    total > props.max ? (props.completed / total) * props.max : props.completed
  let assigned =
    total > props.max ? (props.assigned / total) * props.max : props.assigned
  let unassigned =
    total > props.max
      ? (props.unassigned / total) * props.max
      : props.unassigned

  return (
    <>
      <PerformanceBarWrapper>
        <Barchart width={completed * props.multiplier} className="completed" />
        <Barchart width={assigned * props.multiplier} className="assigned" />
        <Barchart
          width={unassigned * props.multiplier}
          className="unassigned"
        />
      </PerformanceBarWrapper>
    </>
  )
}
